//  actions
import TYPES from './types'

//  initialState
import initialState from './initialState'

// Model
import model from './model'

export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.ACCOUNTS.FETCH.REQUEST:
      return model.loading(state)
    case TYPES.ACCOUNTS.FETCH.SUCCEEDED:
      return model.capturedResponse(state, action.payload)
    case TYPES.ACCOUNTS.FETCH.FAILED:
      return model.error(state, action.payload)
    case TYPES.ACCOUNTS.CLEAN.ERRORS:
      return model.clean(state)
    case TYPES.ACCOUNTS.CLEAN.STATE:
      return model.clean(initialState)
    default:
      return state
  }
}
